define("SDB.SDBLocations.SocialMedia.View", [
  "SCView",
  "SDB.SDBLocations.Model",
  "sdb_locations_socialmedia_template.tpl",
], function (SCViewComponent, SDBSDBLocationsModel, socialmedia_tpl) {
  "use strict";

  var SCView = SCViewComponent.SCView;

  function SDBLocationsSocialMediaView(options) {
    SCView.call(this);

    this.options = options || {};
    this.template = socialmedia_tpl;

    this.model = SDBSDBLocationsModel.getInstance();
    this.config = this.options.container.getConfig();

    this.model.on(
      "change:location",
      function () {
        this.updateSocialMedia();
        this.render();
      },
      this
    );

    this.updateSocialMedia = function () {
      var location = this.model.getSelectedLocation();
      if (!location) return [];

      var socialMedia = this.config.SDBLocations.SocialMedia;

      this.socialMedia = _.filter(socialMedia, function (socialMedia) {
        return socialMedia.id === location.internalid;
      });

      return this.socialMedia;
    };

    this.socialMedia = this.updateSocialMedia();

    this.attributes = {
      id: "SDBLocationsSocialMediaViewId",
      class: "sdb-locations-socialmedia-view",
    };

    this.getContext = function getContext() {
      var facebookConfig = _.findWhere(this.socialMedia, { name: "facebook" });
      var linkedinConfig = _.findWhere(this.socialMedia, { name: "linkedin" });
      var instagramConfig = _.findWhere(this.socialMedia, {
        name: "instagram",
      });
      var facebookUrl = _.get(facebookConfig, "url");
      var linkedinUrl = _.get(linkedinConfig, "url");
      var instagramUrl = _.get(instagramConfig, "url");
      var facebookImage =
        _.get(facebookConfig, "image") || "/site/Home Assets/icon_facebook.png";
      var linkedinImage =
        _.get(linkedinConfig, "image") || "/site/Home Assets/icon_linkedin.png";
      var instagramImage =
        _.get(instagramConfig, "image") ||
        "/site/Home Assets/icon_instagram.png";

      return {
        socialMedia: this.socialMedia,
        facebookUrl: facebookUrl,
        linkedinUrl: linkedinUrl,
        instagramUrl: instagramUrl,
        facebookImage: facebookImage,
        linkedinImage: linkedinImage,
        instagramImage: instagramImage,
      };
    };
  }

  SDBLocationsSocialMediaView.prototype = Object.create(SCView.prototype);
  SDBLocationsSocialMediaView.prototype.constructor =
    SDBLocationsSocialMediaView;

  return SDBLocationsSocialMediaView;
});
